import { Container } from '@mui/material'
import { useCallback } from 'react'
import { ChevronRight } from 'react-feather'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import TableMui from 'src/components/TableMui'
import TextFieldMui from 'src/components/TextFieldMui'
import { actions } from 'src/features/basic-queries/BasicQueriesState'
import { Address, AddressList } from 'src/features/basic-queries/BasicQueriesTypes'
import { Inline } from 'src/features/basic-queries/components/BasicQuery.styles'
import { BasicQueriesHeader } from 'src/features/basic-queries/components/Header/Header'
import { ProductInfoCard } from 'src/features/basic-queries/components/ProductInfoCard/ProductInfoCard'
import { State } from 'src/features/types'
import { useSelector } from 'src/utils/store'

interface FormType{
  barcode: string
}

export const ProductBatch = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const productInfo = useSelector((state: State) => state.basicQuery.productInfo)
  const { register, handleSubmit, formState: { errors } } = useForm<FormType>({ defaultValues: { barcode: productInfo?.barcode ?? '' } })

  const onSubmit = (data: FormType) => {
    dispatch(actions.getProductInfoByBarcode(data.barcode))
  }

  const goToDetail = (row: Address) => {
    history.push(`/basic-queries/product-info/${productInfo?.barcode}/address/${row.addressFormated}`)
  }

  const resolveRows = (addresses: Address[]) => addresses.map((item) => (
    {
      ...item,
      quantityComponent: <Inline>{item.quantity} <ChevronRight/></Inline>,
    }
  ))

  const resolveProductList = useCallback(() => productInfo?.addresses.reduce<AddressList>((addressList, currentAddress) => {
    if (currentAddress.directShelf) {
      addressList.direct.push(currentAddress)
      return addressList
    }

    addressList.other.push(currentAddress)
    return addressList
  }, { direct: [], other: [] }),
  [productInfo])

  const resolvedBatchLists = resolveProductList()

  return (
    <Container>
      <BasicQueriesHeader title='Estoque de Produto'/>
      <form onSubmit={handleSubmit(onSubmit)}>
        <TextFieldMui
          inputProps={{ ...register('barcode', { required: true }) }}
          error={!!errors.barcode}
          name='barcode'
          label='barcode'
          testId='barcode'
          variant='outlined'
          autoFocus
          fullWidth
        />
      </form>

      {
        productInfo && (
          <>
            <ProductInfoCard
              description={productInfo.productDescription}
              idModel={productInfo.idModel}
              productCode={productInfo.productCode}
            />

            {
              !!resolvedBatchLists?.direct.length && (
                <TableMui
                  flatTable
                  columns={[
                    { id: 'addressFormated', label: 'Endereços de Gôndola' },
                    { id: 'quantityComponent', label: 'Estoque' },
                  ]}
                  onRowClick={goToDetail}
                  rows={resolveRows(resolvedBatchLists.direct)}
                />
              )
            }

            {
              !!resolvedBatchLists?.other.length && (
                <TableMui
                  containerStyle={{ marginTop: '16px' }}
                  flatTable
                  columns={[
                    { id: 'addressFormated', label: 'Endereços de Reserva' },
                    { id: 'quantityComponent', label: 'Estoque' },
                  ]}
                  onRowClick={goToDetail}
                  rows={resolveRows(resolvedBatchLists.other)}
                />
              )
            }
          </>
        )
      }

    </Container>
  )
}
